var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeWidth: 3,
    d: "M35 68q-.591 0-1.097-.084a7 7 0 0 1-1.012-.25Q21.5 63.906 14.75 53.756T8 31.909v-15.79q0-2.089 1.223-3.76a6.96 6.96 0 0 1 3.164-2.422l20.25-7.52A7 7 0 0 1 35 2q1.182 0 2.362.418l20.25 7.519a6.96 6.96 0 0 1 3.165 2.423A6.2 6.2 0 0 1 62 16.119v15.79q0 11.696-6.75 21.847-6.75 10.15-18.14 13.91a7 7 0 0 1-1.013.25A7 7 0 0 1 35 68Z",
    opacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M23.588 32.519V27.19c0-6.18 5.01-11.19 11.19-11.19v0c6.18 0 11.19 5.01 11.19 11.19v5.329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M22 32.763a3 3 0 0 0-3 3v10.07a8 8 0 0 0 8 8h15.604a8 8 0 0 0 8-8v-10.07a3 3 0 0 0-3-3zm17.367 8.428c0 1.56-.847 2.922-2.107 3.65v2.671a2.107 2.107 0 0 1-4.214 0v-2.67a4.214 4.214 0 1 1 6.32-3.65",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M37.26 44.841a4.214 4.214 0 1 0-4.214 0v2.67a2.107 2.107 0 1 0 4.214 0z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
};
export default SvgSecurity;